import { createApi } from "@reduxjs/toolkit/dist/query/react";
import { baseQueryWithProvider } from "@/redux/baseQuery";

export const businessApi = createApi({
  reducerPath: "businessApi",
  baseQuery: baseQueryWithProvider("profile"),
  endpoints: () => ({}),
});
